import { useProjectDataStore } from "@state/projectDataStore"
import { useStore } from "@state/store"
import { useEffect, useState } from "react"
import styled from "styled-components/macro"
import gsap from "gsap"
import useViewsPublicURL from "@src/hooks/useViewsPublicURL"
import SphericalTour from "./SphericalTour/SphericalTour"

const ViewSection = ({ viewID }) => {
  const { viewsData } = useProjectDataStore((s) => ({
    viewsData: s.viewsData,
  }))
  console.log("viewID", viewID)
  const [view, setView] = useState(0)

  const publicURLs = useViewsPublicURL(viewID, viewsData.viewMedia)

  const contentControls = useStore((s) => s.contentControls)

  useEffect(() => {
    gsap.to("#view", {
      autoAlpha: contentControls?.index === 1 ? 1 : 0,
      duration: 0.6,
      ease: "power3.inOut",
    })
  }, [contentControls])

  return (
    <Wrapper id="view">
      {/* <SphericalTour
        texture={"/assets/imgs/view.webp"}
        initialPosition={[0, 0, 0]}
      /> */}
    </Wrapper>
  )
}

export default ViewSection

const Wrapper = styled.div`
  opacity: 0;
  width: 100%;
  height: 100%;
  background-color: var(--primary);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  cursor: grab;

  .view-controls {
    position: absolute;

    border-radius: 5px;
    overflow: hidden;

    z-index: 110;

    right: 0;
    bottom: 0;
    margin: 2rem;
    display: flex;
    transition: 0.3s;

    .buttons {
      background-color: var(--primary);
      backdrop-filter: blur(1px);
      color: var(--secondary);
      padding: 0.5rem 2rem;
      cursor: pointer;
      transition: 0.3s;
    }

    .active {
      background-color: var(--secondary);
      filter: blur(0px);
      color: white;
      transition: 0.3s;
    }
  }
`

const View = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
